/* eslint-disable */
import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
  Dropdown,
} from "antd";
import React, { forwardRef, useEffect, useState } from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  FormOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import parse from "html-react-parser";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.css";
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal";
import { CustomTable, CustomTableExtend, CustomUpload } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { useLocation } from "react-router-dom";
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [detailRecord, setDetailRecord] = useState({});
  const [approvedOrRejected, setApprovedOrRejected] = useState("Approved");
  const [approvalForm] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);
  const [checkApprovalList, setCheckApprovalList] = useState([]);

  const initTableHead = {
    vendid: null,
    prop: null,
    addressUnits: null,
    glTitle: null,
    unit: null,
    payBy: null,
    invoiceTnt: null,
    dueDate: null,
    payAmount: null,
    groupedPayments: null,
    customer: null,
    approvalStatus: null,
    rejectedReason: null,
    usid: null,
    historyUserId: null,
    updatedDate: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: 300,
    });
  };

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();

  // 定义列，包括输入框
  const initColumns = [
    // {
    //   title: "#",
    //   dataIndex: "#",
    //   width: 50,
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hidden: false,
      width: 60,
      align: "center",
      render: (text, record, index) =>
        ((commonFn.btnAuthorityFlag("ViewTrust") ||
          commonFn.btnAuthorityFlag("ViewProperty") ||
          commonFn.btnAuthorityFlag("ViewCheckRegister") ||
          commonFn.btnAuthorityFlag("ViewGeneralLedger")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("ViewTrust") && {
                  key: "ViewTrust",
                  icon: <FormOutlined twoToneColor="#1677FF" />,
                  label: <div>View Trust {record.trust}</div>,
                },
                commonFn.btnAuthorityFlag("ViewProperty") && {
                  key: "ViewProperty",
                  icon: <FormOutlined twoToneColor="#1677FF" />,
                  label: <div>View Property {record.prop}</div>,
                },
                commonFn.btnAuthorityFlag("ViewCheckRegister") && {
                  key: "ViewCheckRegister",
                  icon: <FormOutlined twoToneColor="#1677FF" />,
                  label: <div>View Check Register</div>,
                },
                commonFn.btnAuthorityFlag("ViewGeneralLedger") && {
                  key: "ViewGeneralLedger",
                  icon: <FormOutlined twoToneColor="#1677FF" />,
                  label: <div>View General Ledger</div>,
                },
              ],
              // onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        )) ||
        null,
    },
    {
      title: "Prop",
      dataIndex: "prop",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 60,
      onChange: (e) => tableFilterFn(e, "prop"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 200,
      onChange: (e) => tableFilterFn(e, "remark"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      titleType: "Input",
      isSorter: true,
      isAmountFlag: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "amount"),
      render: (text, record) => {
        return (
          <Button
            // disabled={true}
            type="link"
            onClick={() => (setDetailRecord(record), setFiledModalFlag(true))}
            className="CA-AS-AmountStyle"
          >
            {commonFn.amountToDollarFn(text)}
          </Button>
        );
      },
    },
    // {
    //   title: 'Type',
    //   dataIndex: "type",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   width:130,
    //   selectOptions: checkApprovalList,
    //   onChange: e => tableFilterFn(e, 'type', 'Select'),
    // },
    // {
    //   title: 'File',
    //   dataIndex: "preCalFile",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   render: (text, record) => {
    //     return (
    //       <Button
    //         // disabled={true}
    //         type="link"
    //         onClick={() => (setDetailRecord(record), setFiledModalFlag(true))}
    //         style={{textDecoration: 'underline', fontSize: '14px', height:'unset', color: '#2563EB', padding: 0}}
    //       >
    //         View
    //       </Button>
    //     )
    //   },
    // },
    {
      title: "Vendor",
      dataIndex: "vendid",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 150,
      onChange: (e) => tableFilterFn(e, "vendid"),
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
          }}
        >
          <span>{text}</span>
          <Tooltip title={parse(record?.preCalPre || "")}>
            <MenuOutlined
              style={{ marginLeft: 8, cursor: "pointer", color: "#a94442" }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "GL",
      dataIndex: "glAcct",
      titleType: "Input",
      width: 80,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "glAcct"),
    },
    // {
    //   title: "Approval Status",
    //   dataIndex: "approve",
    //   titleType: "Input",
    //   width: 150,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'approve'),
    // },
    // {
    //   title: 'Customer #',
    //   dataIndex: "customerAccount",
    //   titleType: 'Input',
    //     width: 150,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'customerAccount'),
    // },
    {
      title: "Inv Date",
      dataIndex: "invoiceDate",
      titleType: "DatePicker",
      isSorter: false,
      width: 100,
      onChange: (e) => tableFilterFn(e, "invoiceDate", "DatePicker"),
    },
    // {
    //   title: 'H Bill',
    //   dataIndex: "highBill",
    //   titleType: 'Select',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   selectOptions: [
    //     { label: "No", value: "0" },
    //     { label: "Yes", value: "1" },
    //   ],
    //   render: (text) => {
    //     const requestStatusMatch = {
    //       "0": "No",
    //       "1": "Yes",
    //     }
    //     return requestStatusMatch[text] || ""
    //   },
    //   onChange: e => tableFilterFn(e, 'highBill', 'Select'),
    // },
    // {
    //   title: 'Trust',
    //   dataIndex: "trust",
    //   titleType: 'Input',
    //   width: 110,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'trust')
    // },
    // {
    //   title: "Prop Type",
    //   dataIndex: "propType",
    //   key: "propType",
    //   hidden: false,
    //   align: "center",
    //   width: 120,
    //   isSorter: true,
    //   sortterMultiple: 2,
    //   titleType: "Select",
    //   selectOptions: propTypeList,
    //   onChange: (e) => tableFilterFn(e, 'propType', 'Select'),
    // },
    // {
    //   title: "Unit",
    //   dataIndex: "unit",
    //   titleType: "Input",
    //   isSorter: true,
    //   width:80,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'unit'),
    // },
    // {
    //   title: "# Units",
    //   dataIndex: "numberOfUnits",
    //   titleType: "Input",
    //   isSorter: true,
    //   width:80,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, 'numberOfUnits'),
    // },
    {
      title: "Type - Units",
      dataIndex: "propType",
      titleType: "Select",
      isSorter: true,
      sortterMultiple: 3,
      width: 150,
      selectOptions: propTypeList,
      onChange: (e) => tableFilterFn(e, "propType", "Select"),
    },
    {
      title: "Bank",
      dataIndex: "bank",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        return `(${text}) ${record?.bankList?.[text] || ""}`;
      },
      onChange: (e) => tableFilterFn(e, "bank"),
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "rejectedReason"),
    },
    {
      title: "Updated Date",
      dataIndex: "udate",
      titleType: "DatePicker",
      width: 120,
      onChange: (e) => tableFilterFn(e, "udate", "DatePicker"),
    },
    {
      title: "Usid",
      dataIndex: "usid",
      titleType: "",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "usid"),
    },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 300,
    total: 0,
  });

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn();
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
    };

    const response = await http.get(api.checkApprovalShowOther, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 300);
  }, [refreshKey]);

  useEffect(() => {
    getDictionaryFn(
      {
        type: "checkApproval",
        value: "",
      },
      setCheckApprovalList
    );
    getDictionaryFn(
      {
        type: "util_payment",
        value: "propType",
      },
      setPropTypeList
    );
  }, []);

  useEffect(() => {
    if (checkApprovalList?.length && propTypeList?.length) {
      setColumns(initColumns);
    }
  }, [checkApprovalList, propTypeList]);

  const [btnLoading, setBtnLoading] = useState(false);

  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true);
    const values = await approvalForm.validateFields();
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map((item) => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if (response.code === "1") {
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date());
    } else {
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false);
  };

  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: "1",
      noLimit: "no",
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);

    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  };

  const getDictionaryFn = async (params, fn) => {
    const response = await http.get(api.getDictionary, { params });
    fn(response);
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[
          !commonFn.btnAuthorityFlag("DetailDownload") && "download",
        ]}
      >
        <div className="topLeft">
          <Space size="small">
            {(commonFn.btnAuthorityFlag("Approval") && (
              <Tooltip
                placement="topLeft"
                title="Approval The Requests For Approval From Employee"
              >
                <Button
                  className="btnAgreed"
                  style={{ marginRight: 0 }}
                  onClick={() => approveOrRejectFn("Approved")}
                >
                  <CheckOutlined />
                  Approval Selected({selectedList.length})
                </Button>
              </Tooltip>
            )) ||
              null}
            {/* {commonFn.btnAuthorityFlag('ApprovalAll') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnAgreed" style={{marginRight: 0}} onClick={() => approveOrRejectFn('ApprovedAll')}>
                <CheckOutlined />
                Approval All
              </Button>
            </Tooltip> || null} */}

            {/* <Button
              className="btnAgreed"
              style={{ marginRight: 0 }}
              onClick={() => approveOrRejectFn("ApprovedAll")}
            >
              <CheckOutlined />
              Approval All ({pagination.total})
            </Button> */}

            {(commonFn.btnAuthorityFlag("Reject") && (
              <Tooltip
                placement="topLeft"
                title="Reject The Requests For Approval From Employee"
              >
                <Button
                  className="btnRefused"
                  style={{ marginLeft: 0 }}
                  onClick={() => approveOrRejectFn("rejected")}
                >
                  <CloseOutlined />
                  Reject Selected({selectedList.length})
                </Button>
              </Tooltip>
            )) ||
              null}

            {/* {commonFn.btnAuthorityFlag('RejectAll') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnRefused" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('rejectedAll')}>
               <CloseOutlined />
                Reject All
              </Button>
            </Tooltip> || null} */}

            {/* <Button
              className="btnRefused"
              style={{ marginLeft: 0 }}
              onClick={() => approveOrRejectFn("rejectedAll")}
            >
              <CloseOutlined />
              Reject All({pagination.total})
            </Button> */}

            {(commonFn.btnAuthorityFlag("SelectedAmount") && (
              <Button className="btnAmount" style={{ cursor: "text" }}>
                Selected Amount:
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(
                  selectedList
                    .map((item) => item.amount)
                    .reduce((acc, curr) => acc + curr, 0)
                )}
              </Button>
            )) ||
              null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map((item) => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollX={2100}
        tableCss="checkApprovalDetailTable"
      />

      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${
                    approvedOrRejected === "Approved" ? "Approve" : "Reject"
                  } ${selectedList.length} Check(s).`,
                },
              ]}
            />
          </Form.Item>

          {(approvedOrRejected === "Approved" && (
            <Form.Item
              name="noLimit"
              label={
                <span>
                  Do you want to approve the amount over{" "}
                  {
                    <span
                      style={{ color: "#a94442", textDecoration: "underline" }}
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(5000)}
                    </span>
                  }{" "}
                  with signature
                </span>
              }
              style={{ flex: 1 }}
            >
              <Select
                placeholder="Select option"
                options={[
                  {
                    value: "no",
                    label: "No",
                  },
                  {
                    value: "yes",
                    label: "Yes",
                  },
                ]}
              />
            </Form.Item>
          )) ||
            null}

          {(approvedOrRejected !== "Approved" && (
            <Form.Item
              name="rejectedReason"
              label="Rejected Reason"
              style={{ flex: 2 }}
            >
              <Input placeholder="" />
            </Form.Item>
          )) ||
            null}
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
        <div
          key={detailRecord?.vendorPaymentId}
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <CustomUpload
            setFilePaths={setFilePaths}
            filePaths={filePaths}
            setBtnDisabled={setBtnDisabled}
            btnDisabled={btnDisabled}
            isEdit={true}
            vendorPaymentId={detailRecord?.vendorPaymentId || undefined}
            foreignId={detailRecord?.vendorPaymentId || undefined}
            preCalFile={detailRecord?.preCalFile || undefined}
            type={detailRecord?.type || undefined}
            customConfig={{
              pdfHeight: "62vh",
              noShowUpload: true,
              noSubmitBtn: true,
              pageName: "CheckApproval",
            }}
          />
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button onClick={() => setFiledModalFlag(false)}>cancel</Button>
          </div>
        </div>
      </Modal>
      <AddModal
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {
          setAddOpen(false);
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />
    </div>
  );
});
export default MainTable;
